<script>
	/**
	 * This is a modal that should host a video
	 * title, subtitle, and videoId should be passed through openModal opts
	 */
	module.exports = {
		components: {
			modal: require('./modal.vue').default,
			'vimeo-player': require('./vimeo-player.vue').default
		},
		data: function () {
			return {
				title: 'Video',
				subtitle: null,
				videoId: null
			};
		},
		mounted() {
			this.$subscribe('modal-opened', (id, opts) => {
				if (id !== 'video-modal') {
					return true; // let some other handler take this
				}

				this.title = opts.title || null;
				this.subtitle = opts.subtitle || null;
				this.videoId = opts.videoId || null;

				return false;
			});

			this.$subscribe('modal-closed', id => {
				if (id !== 'video-modal') {
					return true; // let some other handler take this
				}

				this.title = null;
				this.subtitle = null;
				this.videoId = null;

				return false;
			});
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	#video-modal {
		.modal-window-wrap {
			max-width: 800px;
			.vimeo-player {
				width: 100%;
				min-height: 480px;
			}
			.modal-content-main {
				min-height: 480px;
			}
		}
	}
</style>
<template>
	<modal
		ref="modal"
		id="video-modal"
		:ok="false">
		<template slot="header-container">
			<h2>{{ title }}</h2>
			<p
				v-if="subtitle"
				class="font-small signup-subheader">
				{{ subtitle }}
			</p>
		</template>
		<template slot="content">
			<vimeo-player
				v-if="videoId"
				:video-id="videoId"></vimeo-player>
		</template>
	</modal>
</template>
